import { alert } from '@/services/alert';

/**
 * The `openPaymentOrder` action, shared by the warm hand-off card and the PN
 * consultation card (BAR-3070): opens the timeline's payment-order drawer.
 *
 * `onOpenPaymentOrder` comes from the timeline context and is absent when the
 * viewer cannot take payments (outside `PAYMENTS_ROLES`, or with the
 * treatment-payments flag off). The PN card disables its link then; this
 * alert is the fallback, and the warm hand-off's answer.
 */
export function openPaymentOrder(onOpenPaymentOrder: (() => void) | undefined): void {
  if (!onOpenPaymentOrder) {
    alert.error(
      'You do not have access to payment orders. Ask a Patient Navigator, Patient Access or Care Coordinator teammate.'
    );
    return;
  }

  onOpenPaymentOrder();
}
